<script>
import { Swiper, Pagination, Autoplay } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'

export default {
  name: 'MySwiperComponent',
  emit: ['update-index'],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiper: null, // 存 Swiper 實例
    };
  },
  watch: {
    data: {
      deep: true,
      handler(newData) {
        if (newData.length >= 1) {
          this.$nextTick(() => {
            this.initSwiper();
          });
        } else {
          this.destroySwiper(); // 沒有資料時銷毀 Swiper
        }
      },
    },
  },
  mounted() {
    if (this.data.length > 1) {
      this.$nextTick(() => {
        this.initSwiper();
      });
    }
  },
  beforeDestroy() {
    this.destroySwiper(); // 組件銷毀時移除 Swiper
  },
  methods: {
    initSwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true); // 先銷毀已存在的 Swiper
      }
      this.swiper = new Swiper('.banner_swiper-container', {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 500,
        watchSlidesProgress: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        modules: [Pagination, Autoplay],
        on: {
          progress: swiper => {
            swiper.slides.forEach(slide => {
              const slideProgress = slide.progress
              const translateY = 18 * Math.abs(slideProgress).toFixed(2)
              slide.style.transform = `translateY(${translateY}px)`
              slide.style.outline = `solid ${Math.min(6, Math.max(0, ((1 - Math.abs(slideProgress)) * 1.5).toFixed(1)))}px #fff`
            })
          },
          setTransition: (swiper, duration) => {
            swiper.slides.forEach(slide => {
              slide.style.transition = `transform ${duration}ms`
            })
          },
          slideChange: el => {
            this.$emit('update-index', el.realIndex)
          },
        },
      })
    },
    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },
  },
}
</script>
<template>
  <div v-if="data.length >= 1" class="banner_swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(info, index) in data" :key="`${info}${index}`">
        <img :src="info" alt="" style="" />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<style scoped>
.banner_swiper-container {
  width: 100%;
  /* height: 200px; */
  padding: 16px 0px 20px;
  overflow: hidden;
  position: relative; /* 分頁指示器需要相對定位 */
  z-index: 1;
}
.swiper-slide {
  width: auto; /* 自動由 Swiper 控制寬度 */
  border-radius: 10px;
  overflow: hidden;
  box-shadow: -1px 2px 10px -2px #4b251814, 1px 1px 4px -2px #4b25181f;
  transition: aspect-ratio 0.3s ease, transform 0.3s ease;
}
:deep(.swiper-slide) {
  aspect-ratio: 300/160 !important;
}

:deep(.swiper-slide-active) {
  aspect-ratio: 312/166.7 !important;
}
.swiper-slide img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}
:deep(.swiper-pagination) {
  position: absolute;
  bottom: -4px;
  left: 0;
  right: 0;
  text-align: center;
}

:deep(.swiper-pagination-bullet) {
  background-color: #fff;
  opacity: 1;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  transition: 0.3s;
}

:deep(.swiper-pagination-bullet-active) {
  width: 12px;
  border-radius: 10px;
  background-color: #ff7649;
}
</style>
